import type { Auth0Client } from './types';

export const getAuth0 = (): Auth0Client | false =>
  typeof window !== 'undefined' && window.auth0;
